import React from 'react';

const RentalRequestAdminThumbType = () => {
    return (
        <div>

        </div>
    );
};

export default RentalRequestAdminThumbType;